import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import {
  getSingleSignOnConfiguration,
  GetSingleSignOnConfiguration$Params,
} from '../../api/fn/employee-single-sign-on/get-single-sign-on-configuration';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SsoLogout$Params } from '../../api/fn/employee-single-sign-on/sso-logout';
import { GetSsoConfigurationResponse } from '../../api/models';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SingleSignOnService {
  constructor(private apiService: ApiService, private http: HttpClient) {}

  getEmployeeSSO(
    params: GetSingleSignOnConfiguration$Params
  ): Observable<GetSsoConfigurationResponse> {
    return this.apiService.invoke(getSingleSignOnConfiguration, params);
  }

  getEmployeeLogoutRedirect(params: SsoLogout$Params): string {
    return `${environment.apiConfig.ssoUri}/v1/organizations/${params.organizationId}/sso/logout`;
  }
}
